export default __webpack_public_path__ + "images/b3f413de98016f0ce3ac3122d4ad43bf-softball.jpg";